module.exports = __webpack_public_path__ + "img/ep-4-dosis.7cdb2e49.jpg";